// 1、系统-企业、
// 2、系统-人员、
// 3、短文本、
// 4、长文本、
// 5、日期、
// 6、下拉选择、
// 7、单选、
// 8、复选、
// 9、数值、
// 10、手机号码、
// 11、邮箱、
// 12、图片、

import { FieldType } from "../type";

// too bar 的几种类型
export enum ToolBarType {
  // 资料目录
  PACKAGE_INFO = "packageInfo",
  // 项目信息
  PROJECT_INFO = "projectInfo",
  // 文档信息
  DOCUMENT_INFO = "documentInfo",
  // 字段域
  FIELD_DOMAIN = "fieldDomain",
  // 项目字段域
  PROJECT_FIELD_DOMAIN = "projectFieldDomain",
}


// 域字段类型枚举
// export enum FieldType {
//   // 系统-企业
//   SYSTEM_COMPANY = "0",
//   // 系统-人员
//   SYSTEM_PERSON = "1",
//   // 短文本
//   SHORT_TEXT = "2",
//   // 长文本
//   LONG_TEXT = "3",
//   // 长日期
//   DATE_LONG = "4",
//   // 短日期
//   DATE_SHORT = "5",
//   // 下拉域
//   DROPDOWN = "6",
//   // 单选框
//   SINGLE_CHECKBOX = "7",
//   // 复选框
//   CHECKBOX = "8",
//   // 图片域
//   IMAGE = "9",
// }

// export const FieldTypeObj = {
//   [FieldType.SHORT_TEXT]: "text", // 文本域
//   [FieldType.LONG_TEXT]: "longText", // 长文本域
//   [FieldType.DROPDOWN]: "dropdown", // 下拉域
//   [FieldType.SINGLE_CHECKBOX]: "singleCheckbox", // 单复选框
//   [FieldType.CHECKBOX]: "checkbox", // 复选框
//   [FieldType.DATE_SHORT]: "date", // 日期域
//   [FieldType.DATE_LONG]: "date", // 日期域
//   [FieldType.SYSTEM_COMPANY]: "systemCompany", // 系统-企业
//   [FieldType.SYSTEM_PERSON]: "systemPerson", // 系统-人员
//   [FieldType.IMAGE]: "image", // 图片域
// };

// 域字段配置接口（这是源数据配置）
// export interface DomainFieldConfig {
//   fieldTag: string;
//   fieldName: string;
//   fieldType: FieldType;
//   key: string; // 域的唯一标识
//   placeholder?: string;
//   value?: any | any[];
//   // options?: FieldOption[]; // 下拉框选项
//   defaultValue?: any;
//   // 是否启用
//   // 1-启用，0-禁用
//   isEnable?: boolean;
//   tip?: string;
//   content?: {
//     options?: FieldOption[];
//     isNewLine?: boolean;
//   };
//   dateFormat?: string;
//   noField?: boolean; // 是否不显示域
// }

// 域字段值接口（用户输入的值）
export interface DomainFieldValue {
  fieldId: string;
  value: any;
}

// 域字段分组配置
// export interface DomainGroup {
//   fieldTag: string;
//   fieldName: string;
//   label?: string;
//   fields?: DomainFieldConfig[];
//   children?: DomainGroup[];
// }

